<div
  class="h-full rounded-xl border border-gray-100 bg-white shadow-sm"
  [attr.aria-busy]="loading"
>
  <div class="flex flex-wrap items-baseline gap-2 border-b border-gray-100 px-5 py-4">
    <h3 id="circuit-milestones-chart-title" class="font-lato text-sm font-bold uppercase tracking-wide text-blue-950">
      Circuit Milestones
      <span class="ml-1 font-normal normal-case text-brand-muted">({{ total }} in progress)</span>
    </h3>
    <p class="font-lato text-xs text-brand-muted">Excludes related Voice and SD-WAN orders</p>
  </div>

  @if (loading) {
    <div class="flex items-center justify-center py-16" role="status" aria-label="Loading Circuit Milestones chart">
      <mat-spinner [diameter]="50" aria-hidden="true"></mat-spinner>
    </div>
  } @else {
    <figure class="m-0 px-4 py-2">
      <p id="circuit-milestones-chart-desc" class="sr-only">
        Circuit Milestones bar chart with {{ data.length }}
        {{ data.length === 1 ? 'bar' : 'bars' }}. The data table lists each
        milestone and order count.
      </p>
      <canvas
        baseChart
        id="circuit-milestones-chart"
        role="img"
        aria-label="Bar chart: Circuit Milestones"
        aria-describedby="circuit-milestones-chart-desc"
        height="320px"
        [data]="barChartData"
        [options]="barChartOptions"
        [plugins]="barChartPlugins"
        [type]="barChartType"
      ></canvas>

      <figcaption class="sr-only">
        <h4 id="circuit-milestones-chart-table-title">
          Circuit Milestones data table
        </h4>
        <table aria-labelledby="circuit-milestones-chart-table-title">
          <caption>
            Circuit Milestones data points
          </caption>
          <thead>
            <tr>
              <th scope="col">Milestone</th>
              <th scope="col">Orders</th>
            </tr>
          </thead>
          <tbody>
            @for (item of data; track item.label) {
              <tr>
                <th scope="row">{{ item.label }}</th>
                <td>{{ item.value }}</td>
              </tr>
            } @empty {
              <tr>
                <td colspan="2">No chart data available</td>
              </tr>
            }
          </tbody>
        </table>
      </figcaption>
    </figure>
  }
</div>
